
import {defineComponent, SetupContext} from 'vue'
import { alertController, IonModal, IonPage, IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonLabel, IonTextarea, IonInput, IonButton } from "@ionic/vue"
import axios from 'axios';
  import { useRouter } from 'vue-router';

export default defineComponent({
    name: "SimpleModal",
    components:{ IonModal, IonPage, IonContent, IonHeader, IonTitle, IonToolbar,},
    
    props:{
        isOpen: {
            default: false,
            required: true,
        },
    },
    setup(props: any, ctx: SetupContext){
       const router = useRouter();
        const handleDidDismiss = (isCancelled: boolean) => {
            // Ignore the onDidDismiss if we closed from a button click
            if ( !props.isOpen) return;
            console.log(isCancelled);
            ctx.emit('modal-closed', { isCancelled });
        };
        return {
            handleDidDismiss,
            router
        };
    },
    data() {
        return {
        playlistInput:'',
        nameInput:'',
        error: ''
        }
    },
    methods:{
    convert(){
    //   alert(this.playlistInput)
    //   alert(this.nameInput)
      if (!this.playlistInput){
           const rerror = this.error = "1"
        return rerror
      }

      else{
          const userpid = localStorage.getItem("userID")
          const usertoken = localStorage.getItem("accesstoken")
          console.log("OK")
          const rsuccess = this.error ="2"
          this.Loading()
          axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/addPlaylistMusicsToFirebase?youtubePlaylistId='+ this.playlistInput + '&userId=' + userpid + '&spotifyToken=' + usertoken + '&playlistName=' + this.nameInput)
            .then(

              res => {
              console.log("Success")
              this.presentAlert()
              this.handleDidDismiss(false)
               window.dispatchEvent(new CustomEvent('playlist-deleted', {
                detail: {
                  storage: 'playlist-deleted'
                }
              }));
              
              this.router.push('/music/playlist');
              return
                
              // JSON data parsed by `data.json()` call
            }).catch(err=>{
              console.log("Fail Error")
              this.errorAlert()
              return
            });

          return rsuccess 
      }





    },
    async Loading() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          message: '<img src="https://www.flaticon.com/svg/static/icons/svg/189/189768.svg" class="card-alert"> <br> <p class="card-alert-text">One Moment, Searching Songs</p>'
        });
      return alert.present();
    },
    async presentAlert() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          message: '<img src="https://www.flaticon.com/svg/static/icons/svg/130/130879.svg" class="card-alert"> <br> <p class="card-alert-text">Successfully added</p>',
          buttons: ['Close']
        });
      return alert.present();
    },
    async errorAlert() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          message: '<img src="https://www.flaticon.com/svg/static/icons/svg/748/748122.svg" class="card-alert"> <br> <p class="card-alert-text">No Songs added</p>',
          buttons: ['Close']
        });
      return alert.present();
    },
 

    }

});


